import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'investorId',
    label: 'Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLoanNumber',
    label: 'Investor Loan Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'conditions',
    label: 'Investor Conditions',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dueDate',
    label: 'Due Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorPackageUploadedDate',
    label: 'Package Uploaded Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'commitmentNumber',
    label: 'Commitment Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const investorForm = {
  name: FormNames.POST_CLOSING,
  label: 'Investor',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
